// extracted by mini-css-extract-plugin
export default {"Container":"NotFound_Container__k+0Gl"};